import React from 'react';
import { X, BookOpen } from 'lucide-react';

const ReadingsModal = ({ isOpen, onClose, event }) => {
  if (!isOpen || !event) return null;

  // Parse the readings from the description
  const parseReadings = (description) => {
    if (!description) return [];

    const sections = [];
    const lines = description.split('\n');
    let currentSection = null;

    lines.forEach((line) => {
      const trimmedLine = line.trim();

      if (!trimmedLine) return;

      // Check if this line is a section header (Evening, Morning, etc.)
      if (
        trimmedLine === 'Evening' ||
        trimmedLine === 'Morning' ||
        trimmedLine === 'Before Holy Qurbana' ||
        trimmedLine === 'Holy Qurbana'
      ) {
        if (currentSection) {
          sections.push(currentSection);
        }
        currentSection = {
          title: trimmedLine,
          readings: []
        };
      } else if (currentSection) {
        // This is a reading reference
        currentSection.readings.push(trimmedLine);
      }
    });

    // Push the last section
    if (currentSection) {
      sections.push(currentSection);
    }

    return sections;
  };

  const readingSections = parseReadings(event.description);

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-red-800 to-red-600 text-white p-6 flex items-start justify-between">
            <div className="flex items-start space-x-3 flex-1">
              <BookOpen className="w-6 h-6 mt-1 flex-shrink-0" />
              <div>
                <h2 className="text-2xl font-bold mb-2">{event.summary}</h2>
                <p className="text-red-100">
                  {(() => {
                    const [year, month, day] = event.date.split('-').map(Number);
                    return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('en-US', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      timeZone: 'UTC'
                    });
                  })()}
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="ml-4 p-2 hover:bg-red-700 rounded-full transition-colors flex-shrink-0"
              aria-label="Close"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
            {readingSections.length > 0 ? (
              <div className="space-y-6">
                {readingSections.map((section, index) => (
                  <div key={index} className="border-l-4 border-red-600 pl-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">
                      {section.title}
                    </h3>
                    <ul className="space-y-2">
                      {section.readings.map((reading, readingIndex) => (
                        <li
                          key={readingIndex}
                          className="flex items-start space-x-2 text-gray-700"
                        >
                          <span className="text-red-600 mt-1">•</span>
                          <span>{reading}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8">
                <BookOpen className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                <p className="text-gray-500">No readings available for this event.</p>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 flex justify-end border-t">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors font-medium"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReadingsModal;